module.exports = __webpack_public_path__ + "img/ektp-medical.39dc7917.png";